import { inject, Injector } from '@angular/core';
import {
	ModulesEnum,
	TransactionRecordCategoryEnum,
	TransactionRecordDto,
} from '@splitsecondconnect/ultramarine-shared';

import { FEATURES } from '../../../../core/features/features';
import { ListComponent } from '../../../../shared/components/list/list.component';
import { ModuleSelectorStrategy } from '../../../../shared/models/module-selector.strategy';
import { LIST_STRATEGY_TOKEN } from '../../../../shared/tokens/list-strategy.token';
import { getTransactionFilters } from '../../transactions/config/transaction-filters.config';
import { TransactionListStrategy } from '../../transactions/config/transaction-list-strategy';
import { TransactionsRecordComponent } from '../../transactions/transactions-record/transactions-record.component';
import { TransactionsRecordResolver } from '../../transactions/transactions-record/transactions-record.resolver';

export class VehicleRoadtaxModuleSelectorStrategy
	implements ModuleSelectorStrategy
{
	#injector = inject(Injector);
	suggestTransaction = true;
	originModule = ModulesEnum.VEHICLE_ROAD_TAXES;
	options = [
		{
			key: 'transactions|title',
			svgIcon: 'payment',
			value: ModulesEnum.TRANSACTIONS,
			component: ListComponent,
			featureFlag: FEATURES.transactions,
			partialDataKey: 'vehicleRoadTaxId',
			hiddenFilterKey: 'vehicleRoadTaxes',
			filters: getTransactionFilters().filter(
				(item) => ![ModulesEnum.VEHICLE_ROAD_TAXES].includes(item.module),
			),
			injector: Injector.create({
				providers: [
					{ provide: LIST_STRATEGY_TOKEN, useClass: TransactionListStrategy },
				],
				parent: this.#injector,
			}),
			newRecordComponent: TransactionsRecordComponent,
			newRecordResolver: TransactionsRecordResolver,
			newRecordPartialData: (id: number): Partial<TransactionRecordDto> => {
				return {
					recordCategory: TransactionRecordCategoryEnum.VEHICLE_ROAD_TAX,
					vehicleRoadTaxId: id,
				};
			},
		},
	];
}
